<div>
    <div class="menu">
        <span class="menu-heading">Live View - {{toPascalCase(AgentName)}}</span>
        <span class="close" (click)="closeModal()">X</span>
    </div>
    <div class="modal-content">
        <div class="modal-body">
            <section class="text-center">
                <button class="outline-btn btn-sm ms-1"
                        type="button"
                        (click)="SetWindowSize('modal-xl')">
                    <i class="bi bi-fullscreen ms-1"></i>  Fit to Window
                </button>
                <button class="outline-btn btn-sm ms-1"
                        type="button"
                        (click)="SetWindowSize('')">
                    <i class="bi bi-arrows-angle-contract ms-1"></i>  Half Size
                </button>
                <button class="outline-btn btn-sm ms-1"
                        type="button"
                        (click)="SetWindowSize('modal-lg')">
                    <i class="bi bi-aspect-ratio ms-1"></i>  Actual Size
                </button>
                <!--<button *ngIf="isMicDisabled" class="outline-btn btn-sm ms-1"
                        type="submit"
                        value="Unmute">
                    <i class="bi bi-mic-mute-fill  ms-1"></i> Unmute
                </button>-->
            </section>
            <section class="text-center" [class.Msghidden]="StatusDetail.MsgView" >
                <div>
                    <div class="ms-1 spinner-grow spinner-grow-sm " [class]="StatusDetail.iconClass" role="status">
                    </div>
                    <span class="ms-1 " [class]="StatusDetail.iconClass">{{StatusDetail.label}}  <span [class.Msghidden]="StatusDetail.isTimedOut">{{ display }}</span></span>
                   
                </div>
                 
            </section>
            <!--screen loading inside the div-->
            <section class="text-center m-2">
                <div id="agentLiveViewer">
                </div>
            </section>
        </div>
    </div>
</div>